import React from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { MoreHorizontal } from "lucide-react";
import ShowIfHasAccess from "@/components/ShowIfHasAccess/ShowIfHasAccess";

interface UserManagementActionMenuProps {
  userUuid: string;
  employeeUuid: string;
  onEdit: (uuid: string) => void;
  onImpersonate: (employeeUuid: string) => void;
  onViewSyncLogs: () => void;
  onSyncUser: () => void;
  isSuperAdmin: boolean;
}

const UserManagementActionMenu: React.FC<UserManagementActionMenuProps> = ({
  userUuid,
  employeeUuid,
  onEdit,
  onImpersonate,
  onViewSyncLogs,
  onSyncUser,
  isSuperAdmin,
}) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          className="h-8 w-8 p-0 hover:bg-gray-200 transition-colors"
          variant="ghost"
        >
          <span className="sr-only">Open menu</span>
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[160px] p-2 bg-white">
        <DropdownMenuItem
          className="flex items-center px-3 py-2 text-sm cursor-pointer hover:bg-gray-100 transition-colors"
          onClick={() => onEdit(employeeUuid)}
        >
          Edit User
        </DropdownMenuItem>
        <ShowIfHasAccess requiredRoles={["ROLE_SUPER_ADMIN"]}>
          <DropdownMenuItem
            className="flex items-center px-3 py-2 text-sm cursor-pointer hover:bg-gray-100 transition-colors"
            onClick={() => onImpersonate(employeeUuid)}
          >
            Impersonate User
          </DropdownMenuItem>
          <DropdownMenuItem
            className="flex items-center px-3 py-2 text-sm cursor-pointer hover:bg-gray-100 transition-colors"
            onClick={onSyncUser}
          >
            Sync User
          </DropdownMenuItem>
          <DropdownMenuItem
            className="flex items-center px-3 py-2 text-sm cursor-pointer hover:bg-gray-100 transition-colors"
            onClick={onViewSyncLogs}
          >
            View Sync Logs
          </DropdownMenuItem>
        </ShowIfHasAccess>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default UserManagementActionMenu;
